// extracted by mini-css-extract-plugin
module.exports = {"payment-disclaimer":"PaymentDisclaimer_payment-disclaimer__3nbru"};